export default __webpack_public_path__ + "static/media/icon-tier.1f2bd12c.svg";